export const AnalyticEvents = {
  CreditLine: {
    CreditLineLimitValuePropPopUp: "Credit_Line_Limit_Value_Prop_Popup",
    JointLoanLineEducationalSliderLoaded:
      "Joint_Loan_Line_Educational_Slider_Loaded",
    JointLoanLineEducationalBannerDismissed:
      "Joint_Loan_Line_Educational_Banner_Dismissed",
    JointLoanLineEducationalBannerShipmentButtonPressed:
      "Joint_Loan_Line_Educational_Banner_Shipment_Button_Pressed",
    CancelCreditLine: "Cancel_credit_line",
    HelpQuestionClicked: "Help_Question_Clicked",
    HelpButton: "Help_Button",
    ClickUpgradeToCL: "Click_Upgrade_to_CL",
    ViewIntroScreen: "View_Intro_Screen",
    ClickApplyNow: "Click_Apply_now",
    ViewOfferLoading: "View_Offer_loading",
    ClickOfferSelected: "Click_Offer_selected",
    ClickRequestInterestRate: "Click_Request_annual_interest_rate",
    ClickTyC: "Click_T_C_triggered",
    ClickPrivacyPolicy: "Click_Privacy_Policy_triggered",
    ClickContract: "Click_Contract_triggered",
    ViewClGenerated: "View_CL_generated",
    ClickDeclineReason: "Click_Decline_reason",
    ContactMoreOptions: "Contact_for_more_options",
    ClickNotInterested: "Click_Not_interested_in_this_offer",
    ClDiscoveryClickNotInterested: "CL_discovery_click_Not_interested",
    ClCancellationRequested: "Cl_Cancellation_Requested",
    ClickContractSigned: "Click_Contract_signed",
    ViewOfferShown: "View_Offer_shown",
    ViewTyC: "View_T_C_and_Contract",
    ClContractDownloaded: "Cl_Contract_Downloaded",
    ViewContractShown: "View_Contract_shown",
    ViewClLoading: "View_CL_loading",
    OfferDeclinedPj: "Offer_Declined_by_PJ",
    ClickWithdraw: "Click_Withdraw",
    ClickDefrostWithdraw: "Click_Defrost_Withdraw",
    OnlineTransferSelected: "Online_transfer_selected",
    CashPickupSelected: "Cash_pickup_selected",
    ClabeScreenView: "CLABE_screen_view",
    ClabeTyping: "CLABE_typing",
    KycCurpScreenView: "KYC_CURP_screen_view",
    KycCurpTyping: "KYC_CURP_typing",
    AccountDetailsConfirmationScreen: "account_details_confirmation_screen",
    OnBoardingOptOut: "OnboardingOptOut",
    OnBoardingOptOutReason: "OnboardingOptOutReason",
    ClickGetCashNowForCL: "Click_Get_Cash_Now_For_CL",
    ClickGetCashNowForCLAlt: "Click_Get_Cash_Now_For_CL_Alt",
    ViewClBanner: "View_CL_Banner",
    ClickWhatIsCL: "Click_What_Is_CL",
    PFHomePageOptOutRequest: "PF_HomePage_OptOut_Request",
    OptOutRequestConfirm: "OptOut_Request_Confirm",
    OptOutRequestCancel: "OptOut_RequestCancel",
    WithdrawOption1: "WithdrawOptionOne",
    WithdrawOption2: "WithdrawOptionTwo",
    WithdrawOption3: "WithdrawOptionThree",
    WithdrawOption4: "WithdrawOptionCustom",
    LastPaymentSettings: "Last_Payment_Settings",
    custom: "Custom_Payment_Amount",
    minimum: "Minimum_Payment_Amount",
    payoff: "Payoff_Payment_Amount",
    OXXO: "Oxxo_Payment_Method",
    CODI: "Codi_Payment_Method",
    BANK: "Bank_Payment_Method",
    SPEI: "Spei_Payment_Method",
    OPENPAY: "Openpay_Payment_Method",
    CcClickWhatIsCc: "Cc_Click_What_is_CC",
    CcClickWhatarebenefits: "Cc_Click_What_are_benefits",
    CcWhereCanUseMyCard: "Cc_Click_where_can_use_my_card",
    CcClickShowDetails: "Cc_Click_Show_Details",
    CcClickTemporaryDisabled: "Cc_Click_Temporary_Disable",
    CcClickOrderCard: "Cc_Click_Order_Card",
    CcClickReceivedCard: "Cc_Click_Received_Card",
    CcClickActivateCard: "Cc_Click_Activate_Card",
    CcShippingFormLoaded: "Cc_Shipping_Form_Loaded",
    MxShippingFormLoaded: "Mx_Shipping_Form_Loaded",
    CoShippingFormLoaded: "Co_Shipping_Form_Loaded",
    CcShippingStartFillout: "Cc_Shipping_Start_Fillout",
    CcCityMissingOnZipCodeCoverageData:
      "Cc_City_Missing_On_Zip_Code_Coverage_Data",
    CcNeighborhoodMissingOnZipCodeCoverageData:
      "Cc_Neighborhood_Missing_On_Zip_Code_Coverage_Data",
    CcShippingAttempt: "Cc_Shipping_Attempt",
    CcShippingFormSentLogs: "Cc_Shipping_Form_Sent_Logs",
    GoogleAutocompleteShown: "Google_Autocomplete_Shown",
    GoogleAutocompleteNotShown: "Google_Autocomplete_Not_Shown",
    CcShippingConfirmDetails: "Cc_Shipping_Confirm_Details",
    CcUserDataFormLoaded: "Cc_User_Data_Form_Loaded",
    CcUserDataStartFillout: "Cc_User_Data_Start_Fillout",
    CcUserDataContinueClick: "Cc_User_Data_Continue_Click",
    CcUserPhoneConfirmationFormLoaded: "Cc_User_Phone_Confirmation_Form_Loaded",
    CcUserPhoneConfirmationStartFillout:
      "Cc_User_Phone_Confirmation_Start_Fillout",
    CcUserPhoneConfirmationContinueClick:
      "Cc_User_Phone_Confirmation_Continue_Click",
    AmlQuestionsViewScreen: "AML_Questions_View_Screen",
    AmlQuestionIncomeSource: "AML_Question_Income_Source",
    AmlQuestionPurposeOfLoan: "AML_Question_Purpose_Of_Loan",
    AmlQuestionIncomeAmount: "AML_Question_Income_Amount",
    AmlQuestionThirdPartyOperation: "AML_Question_Third_Party_Operation",
    AmlQuestionPoliticalCharge: "AML_Question_Political_Charge",
    AmlQuestionFamilyMemberPoliticallyExposed:
      "AML_Question_Family_Member_Politically_Exposed",
    AmlSubmitClick: "AML_Submit_Click",
    CcCalculatorScreenView: "Cc_Calculator_Screen_View",
    CcCalculatorNavFromCardScreen: "Cc_Calculator_Nav_From_Card_Screen",
    ClickHowtoUseVirtualCard: "Click_Howto_Use_Virtual_Card",
    CcClickedCostCalculator: "Clicked_Cost_Calculator",
    UnlinkBankAccountSurveySubmit: "Unlink_Bank_Account_Survey_Submit",
    UnlinkBankAccountSurveyScreenView: "Unlink_Bank_Account_Survey_Screen_View",
    ClickTransactionSearchBar: "Click_transaction_searchbar",
    ClickFilter: "Click_filter",
    ClickFilterDate: "Click_filter_date",
    ClickFilterCategory: "Click_filter_category",
    ClickTransactionDetails: "Click_transaction_details",
    InterestsExplainerView: "Interests_Explainer_Screen_View",
    LimitIncreaseOfferOpened: "Limit_Increase_Offer_Opened",
    LimitIncreaseOfferLoaded: "Limit_Increase_Offer_Loaded",
    LimitIncreaseOfferAccepted: "Limit_Increase_Offer_Accepted",
    LimitIncreaseOfferAcceptanceNotValid:
      "Limit_Increase_Offer_Acceptance_Not_Valid",
    LimitIncreaseOfferAcceptanceAPIError:
      "Limit_Increase_Offer_Acceptance_API_Error",
    DismissCardIntro: "Cc_Origination_Dismiss",
    GoCardShipment: "Cc_Origination_Request_Card",
    GoWithdraw: "Cc_Origination_Withdraw",
    ClickPCBenefitsFromHelp: "Click_benefits_from_help",
    ClickPCBenefitsFromCard: "Click_benefits_from_main_card_screen",
    PageViewPCBenefits: "Page_view_benefits",
    PageViewPCBenefitDetails: "Page_view_benefit_details",
    ClickPCBenefit: "Click_Detail_Benefit",
    WithdrawCardPromo: "Withdraw_Card_Promo",
    UndismissableWithdrawCardPromo: "Undismissable_Withdraw_Card_Promo",
    UsePayjoyCardPopUpWithdrawalBannerClicked:
      "Use_Payjoy_Card_PopUp_Withdrawal_Banner_Clicked",
    SimultaneousLoanLineActivateMyCard: "activate_my_card",
    SimultaneousLoanLineDoNotHaveCard: "do_not_have_card",
    HomePageMessageClick: "home_page_message_click",
    HomePagePhysicalCardBannerClick: "home_page_physical_card_banner_click",
    HomePageVirtualCardBannerClick: "home_page_virtual_card_banner_click",
    // Transaction report related events
    TransactionDetailsView: "Transaction_Details_Screen_View",
    TransactionDetailsAddOnExternalNavigation:
      "Transaction_Details_Add_On_External_Navigation",
    TransactionReportButtonClick: "Transaction_Report_Button_Click",
    TransactionReportValidationFailed: "Transaction_Report_Validation_Failed",
    TransactionReportAPICallAttempt: "Transaction_Report_API_Call_Attempt",
    TransactionReportAPICallError: "Transaction_Report_API_Call_Error",
    TransactionReportExistingFound: "Transaction_Report_Existing_Found",
    TransactionReportNoExistingFound: "Transaction_Report_No_Existing_Found",
    TransactionReportButtonVisibilityCheck:
      "Transaction_Report_Button_Visibility_Check",
    //
    ViewOfferContractCombined: "View_Offer_Contract_Combined",
    AcceptOfferContractCombined: "Accept_Offer_Contract_Combined",
    SitiDataAutoCompleteOptionsShowed: "Siti_Data_Auto_Complete_Options_Showed",
    WithdrawAmountConfirmed: "Withdraw_Amount_Confirmed",
    AutoCompleteProviderUsed: "Auto_Complete_Provider_Used",
    JointLoanLineLimitIncreaseUnlockCardClicked:
      "Joint_Loan_Line_Limit_Increase_Unlock_Card_Clicked",
    JointLoanLineLimitIncreaseAcceptOfferClicked:
      "Joint_Loan_Line_Limit_Increase_Accept_Offer_Clicked",
    WithdrawalEstimateToolTipViewed: "Withdrawal_Estimate_Tool_Tip_Viewed",
    // AddOns Events
    AddOnActivationPageDisplayed: "AddOn_Activation_Page_Displayed",
    AddOnConfirmationPageDisplayed: "AddOn_Confirmation_Page_Displayed",
    AddOnTermsAndConditionsClicked: "AddOn_Terms_And_Conditions_Clicked",
    AddOnActivateServiceClicked: "AddOn_Activate_Service_Clicked",
    AddOnCloseWindowClicked: "AddOn_Close_Window_Clicked",
    AddOnConfirmationCloseClicked: "AddOn_Confirmation_Close_Clicked",
    AddOnLoadingError: "AddOn_Loading_Error",
    AddOnActivationError: "AddOn_Activation_Error",
    AddOnLoadingRetryClicked: "AddOn_Loading_Retry_Clicked",
    AddOnActivationRetryClicked: "AddOn_Activation_Retry_Clicked",
    AddOnSummaryLoadError: "AddOn_Summary_Load_Error",
    AddOnPendingPageDisplayed: "AddOn_Pending_Page_Displayed",
    AddOnPendingCloseClicked: "AddOn_Pending_Close_Clicked",
  },
  CoreAppOnboarding: {
    OnboardingStartScreenView: "Onboarding_Start_Screen_View",
    CoreAppOnboardingSessionStarted: "CoreAppOnboardingSession_Started",
    OnboardingSessionCreated: "Onboarding_Session_Created",
    OnboardingSessionIdFound: "Onboarding_Session_Id_Found",
    DevicePermissionsScreenView: "Device_Permissions_Screen_View",
    AllowPermissionsClick: "Allow_Permissions_Click",
    TransitionScreenView: "Transition_Screen_View",
    ErrorScreenView: "Error_Screen_View",
    ErrorTryAgainClick: "Error_Try_Again_Click",
    LaunchIncodeScreenView: "Launch_Incode_Screen_View",
    CreatedIncodeOnboardingURL: "Created_Incode_Onboarding_URL",
    ValidateIdentityClicked: "Validate_Identity_Clicked",
    ReturnedToLaunchIncodeScreenView: "Returned_To_Launch_Incode_Screen_View",
    ReturnedToValidateIdentityClicked: "Returned_To_Validate_Identity_Clicked",
    IncodeCallbackScreenView: "Incode_Callback_Screen_View",
    ReturnToAppClicked: "Return_To_App_Clicked",
    IncodeResultScreenView: "Incode_Result_Screen_View",
    SeeYourOfferClicked: "See_Your_Offer_Clicked",
    CreditCheckPermissionClearedEsign: "Credit_Check_Permission_Cleared_Esign",
    CurpValidationScreenView: "Curp_Validation_Screen_View",
    CurpValidationDateInputClick: "Curp_Validation_Date_Input_Click",
    CurpValidationLast4CharsInputClick:
      "Curp_Validation_Last_4_Chars_Input_Click",
    CurpValidationCheckboxClick: "Curp_Validation_Checkbox_Click",
    CurpValidationContinueClick: "Curp_Validation_Continue_Click",
    CurpValidationFailedScreenView: "Curp_Validation_Failed_Screen_View",
    OnboardingCreditPullScreenView: "Onboarding_Credit_Pull_Screen_View",
    OnboardingCreditPullSigned: "Onboarding_Credit_Pull_Signed",
    PersonRegLaunchScreenView: "Person_Reg_Launch_Screen_View",
    PersonRegvalidationScreenView: "Person_Reg_Validation_Screen_View",
    PersonRegTagLoginCTAClick: "Person_Reg_Tag_Login_CTA_Click",
    PersonRegTagLoginScreenView: "Person_Reg_Tag_Login_Screen_View",
    PersonRegTagLoginSuccess: "Person_Reg_Tag_Login_Success",
    OMViewLocationPickerScreen: "CL_OM_View_Location_Picker_Screen",
    OMViewKYCStartScreen: "CL_OM_View_KYC_Start_Screen",
    OMKYCFinished: "CL_OM_KYC_Finished",
    OMCreditPullScreenView: "CL_OM_Credit_Pull_Screen_View",
    OMCreditPullSigned: "CL_OM_Credit_Pull_Signed",
    OMViewOfferLoading: "CL_OM_View_Offer_Loading",
    OMOfferContractShown: "CL_OM_Offer_Contract_Shown",
    OMAcceptContract: "CL_OM_Accept_Contract",
  },
};

export default AnalyticEvents;
